const ADDON_FLOW_DISMISSED_KEY = '_addonFlowDismissed';

export function getAddonProvisionRecovery(pendingAddon) {
    if (!pendingAddon || typeof pendingAddon !== 'object') {
        return {projectId: null, projectName: null, responseProjectId: null};
    }

    const projectId = typeof pendingAddon.projectId === 'string' && pendingAddon.projectId.trim() !== ''
        ? pendingAddon.projectId
        : null;
    const responseProjectId = typeof pendingAddon.responseProjectId === 'string'
        && pendingAddon.responseProjectId.trim() !== ''
        ? pendingAddon.responseProjectId
        : null;
    const projectName = projectId === null
        && typeof pendingAddon.projectName === 'string'
        && pendingAddon.projectName.trim() !== ''
        ? pendingAddon.projectName
        : null;

    return {projectId, projectName, responseProjectId};
}

export function retainAddonProvisionTarget(pendingAddon, {projectId = null, projectName = null}) {
    const retained = {...pendingAddon};
    delete retained.projectId;
    delete retained.projectName;

    if (typeof projectId === 'string' && projectId.trim() !== '') {
        return {...retained, projectId};
    }

    return {...retained, projectName: projectName.trim()};
}

export function getAddonProvisionPayload(pendingAddon) {
    const {projectId, projectName} = getAddonProvisionRecovery(pendingAddon);
    const base = {addonType: pendingAddon.type, token: pendingAddon.token};

    return projectId
        ? {...base, projectId}
        : {...base, projectName};
}

export function retainAddonProvisionResponse(pendingAddon, responseProjectId) {
    return {...pendingAddon, responseProjectId};
}

export function acquireAddonSubmissionLock(lock) {
    if (lock.current) {
        return false;
    }

    lock.current = true;
    return true;
}

export function isAddonFlowDismissed(identityId, storage = globalThis.sessionStorage) {
    return typeof identityId === 'string'
        && identityId !== ''
        && storage?.getItem(ADDON_FLOW_DISMISSED_KEY) === identityId;
}

export function clearAddonFlowDismissed(storage = globalThis.sessionStorage) {
    storage?.removeItem(ADDON_FLOW_DISMISSED_KEY);
}

export function cancelPendingAddonConnection({
    identityId,
    persistentStorage = globalThis.localStorage,
    sessionStorage = globalThis.sessionStorage,
    redirect = (path) => globalThis.location.assign(path),
} = {}) {
    persistentStorage.removeItem('_pendingAddon');
    persistentStorage.removeItem('_upgatesPendingToken');
    sessionStorage.setItem(ADDON_FLOW_DISMISSED_KEY, identityId);
    redirect('/');
}

export function getZeroProjectOnboardingRedirect({pathname, hasPendingAddon, addonFlowDismissed}) {
    if (hasPendingAddon) {
        return '/onboarding/addon-project';
    }

    if (pathname === '/' && addonFlowDismissed) {
        return null;
    }

    return '/onboarding/project';
}

export function getProjectOnboardingRedirect({
    pathname,
    currentIdentity,
    currentUserProjectsLoaded,
    currentUserProjectsReload,
    currentUserProjectsCount,
    hasPendingAddon,
}) {
    if (
        pathname !== '/onboarding/project' ||
        !currentUserProjectsLoaded ||
        currentUserProjectsReload !== false ||
        currentUserProjectsCount === 0
    ) {
        return null;
    }

    if (currentIdentity.user.newPasswordRequired) {
        return '/onboarding/password';
    }

    if (
        currentIdentity.user.firstName === '' ||
        currentIdentity.user.lastName === '' ||
        currentIdentity.user.phone === ''
    ) {
        return '/onboarding/info';
    }

    return hasPendingAddon ? '/onboarding/addon-project' : '/';
}

export function getAddonProvisionDestination({responseProjectId, projects, isAdministrator = false}) {
    if (typeof responseProjectId !== 'string' || responseProjectId.trim() === '') {
        return null;
    }

    const project = projects.find(({id}) => id === responseProjectId);
    if (!project) {
        return null;
    }

    const mayManageBilling = isAdministrator
        || project.isOwner === true
        || project.permissions?.includes('ProjectBilling') === true;

    return {
        projectId: project.id,
        path: mayManageBilling
            ? `/project/${project.id}/settings/subscription`
            : '/',
    };
}
